import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api/client";
import type { GardenResponse } from "@/lib/api/types";

export const gardenKeys = {
  all: ["garden"] as const,
};

interface GardenApiResponse {
  data: GardenResponse;
}

export function useGarden() {
  return useQuery<GardenResponse>({
    queryKey: gardenKeys.all,
    queryFn: async () => {
      const result = await apiFetch<GardenApiResponse>("/api/garden");
      return result.data;
    },
    staleTime: 30_000,
  });
}
